export default "__VITE_ASSET__BfPpK8F2__"